
import Faqsbaner from '@/components/faqs/faqsbaner';
import Faquestions from '../../components/faqs/faquestions';

import Head from 'next/head';
import { useEffect } from 'react';
import { getGuestLogDetailsApi } from '@/components/action/easycampus';


export default function Faqs() {

  useEffect(() => {
    handleGestLogUserData();

  }, []);

  const handleGestLogUserData = async () => {
    try {
      let data = {
        pageName:"Faq's"
      }
      
      const res = await getGuestLogDetailsApi(data);
      return;
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <Head>
        <title>Automate Campus Placement | Virtual Campus Hiring By EasyCampus</title>
        <meta property="og:type" content="website" />
        <meta name="description" content={"Campus placement software to automate placement processes, improve placement conversions, streamline seamless data protection and management, showcase talent in a better way."} />
        <meta property="og:title" content={"Campus placement software to automate placement processes, improve placement conversions, streamline seamless data protection and management, showcase talent in a better way."} />
        <meta name="description" content={"Campus placement software to automate placement processes, improve placement conversions, streamline seamless data protection and management, showcase talent in a better way."} />
        <meta name="keywords" content={"Easycampus"} />
        <meta property="og:url" content={"www.easycampus.in"} />
        <meta property="og:description" content={"Campus placement software to automate placement processes, improve placement conversions, streamline seamless data protection and management, showcase talent in a better way."} />
        <meta property="og:image" content={'https://ec-images.s3.ap-south-1.amazonaws.com/easycampus-logo-for-video.png'} />
      </Head>
      <main className="flex min-h-screen flex-col">
        <div className="w-full mx-auto">
          <Faqsbaner />
          <Faquestions />
        </div>
      </main>
    </>
  );
}
